import React from "react";
import { Linking, StyleSheet, View } from "react-native";
import { Box, Text } from "native-base";
import { ScrollView } from "react-native-gesture-handler";
import { BackButtonBackHome } from "../Universal/Buttons/BackButtonBackHomeModified";
import { useAppContext } from "../Universal/API/Context-API/AppContext";
import { webFont } from "../Universal/API/API";
import SimpleCenteredSpinner from "../Universal/SimpleCenteredSpinner/SimpleCenteredSpinner";
import { useSmartNavigate } from "../Universal/API/Context-API/hooks/useSmartNavigate";
import CollectionPreviewCard from "./Components/CollectionPreviewCard";

interface CollectionsProps {
  navigation: any;
  route: any;
  scrollViewRef: any;
}

const createStyles = (scaleAll: number) =>
  StyleSheet.create({
    screen: {
      flex: 1,
      backgroundColor: "#FFFFFF",
    },
    scrollContent: {
      paddingTop: 42 * scaleAll,
      paddingBottom: 88 * scaleAll,
      paddingHorizontal: 16 * scaleAll,
    },
    shell: {
      width: "100%",
      maxWidth: 1560 * scaleAll,
      alignSelf: "center",
    },
    hero: {
      paddingTop: 10 * scaleAll,
      paddingHorizontal: 4 * scaleAll,
    },
    heroTitle: {
      fontFamily: webFont("Inter"),
      fontSize: 28 * scaleAll,
      lineHeight: 32 * scaleAll,
      color: "#111111",
      fontWeight: "700",
      marginBottom: 4 * scaleAll,
      maxWidth: 900 * scaleAll,
    },
    gridWrap: {
      marginTop: 10 * scaleAll,
      flexDirection: "row",
      flexWrap: "wrap",
      gap: 10 * scaleAll,
      alignItems: "flex-start",
    },
  });

const Collections: React.FC<CollectionsProps> = ({ navigation }) => {
  const { allCollectionsData, isSmallVersion, isMediumVersion, scaleAll } = useAppContext();
  const { smartNavigate } = useSmartNavigate({ navigation });
  const styles = React.useMemo(() => createStyles(scaleAll), [scaleAll]);

  const collections = React.useMemo(() => {
    if (!allCollectionsData) return [];

    return Object.values(allCollectionsData);
  }, [allCollectionsData]);

  const cardWidth = React.useMemo(() => {
    if (isSmallVersion) return "48.7%";
    if (isMediumVersion) return "49.1%";
    return "24.2%";
  }, [isMediumVersion, isSmallVersion]);

  return (
    <>
      <View style={styles.screen}>
        <View style={{ position: "absolute", width: "100%", left: 0, zIndex: 10000 }}>
          <BackButtonBackHome navigation={navigation} />
        </View>

        <ScrollView contentContainerStyle={styles.scrollContent}>
          <View style={styles.shell}>
            <View style={styles.hero}>
              <Text selectable={false} style={styles.heroTitle}>
                Коллекции Deante
              </Text>
            </View>

            {!allCollectionsData ? (
              <Box height={320 * scaleAll} justifyContent="center" alignItems="center">
                <SimpleCenteredSpinner scaleAll={scaleAll} width={22} height={22} />
              </Box>
            ) : (
              <View style={styles.gridWrap}>
                {collections.map((collection) => (
                  <CollectionPreviewCard
                    key={collection.collection_name}
                    collection={collection}
                    scaleAll={scaleAll}
                    width={cardWidth}
                  onPress={() => {
                      smartNavigate({
                        navigation,
                        goTo: "Collection",
                        data: {
                          collection_name: collection.collection_name,
                        },
                      });
                    }}
                    onOpenPdf={
                      collection.link_pdf
                        ? () => {
                            Linking.openURL(collection.link_pdf);
                          }
                        : undefined
                    }
                  />
                ))}
              </View>
            )}
          </View>
        </ScrollView>
      </View>
    </>
  );
};

export default React.memo(Collections);
